import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import clsx from "clsx";

// Styles
import "./styles.css";

// Layouts
import TierAlertError from "@Layouts/components/Tiers/TierAlertError";

// MUI
import { Checkbox, Divider, FormControlLabel, Stack, Typography } from "@mui/material";

export default function Queues(props) {
	const { data = null, showDivider = true, readOnly = false, onActionChange = () => {} } = props;

	// States
	const [checks, setChecks] = useState(null);

	const handleChangeCheck = (area, value) => {
		setChecks({ ...checks, [area]: value });
		onActionChange?.(area, value);
	};

	const isValid = useMemo(() => checks?.hasQueues || checks?.individual, [checks]);

	useEffect(() => {
		setChecks(data);

		return () => {
			setChecks(null);
		};
	}, [data]);

	return (
		<Stack width={1}>
			{showDivider && (
				<Stack>
					<Divider
						sx={{
							borderColor: "var(--disabled-and-stroke-color)",
						}}
					/>
				</Stack>
			)}
			<Stack direction="row" spacing={2} mt={1}>
				<FormControlLabel
					className={clsx({
						"checkbox-error": !isValid,
						"text-primary": true,
					})}
					control={
						<Checkbox
							className={clsx({
								"!text-primary": Boolean(checks?.hasQueues) && !readOnly,
								"!text-disabled": readOnly,
							})}
							checked={Boolean(checks?.hasQueues)}
							disabled={readOnly}
							onChange={(_, value) => handleChangeCheck("hasQueues", value)}
						/>
					}
					label={<Typography className="queue-title">Queue</Typography>}
					labelPlacement="end"
				/>
				<FormControlLabel
					className={clsx({
						"checkbox-error": !isValid,
					})}
					control={
						<Checkbox
							className={clsx({
								"!text-primary": Boolean(checks?.individual) && !readOnly,
								"!text-disabled": readOnly,
							})}
							checked={Boolean(checks?.individual)}
							disabled={readOnly}
							onChange={(_, value) => handleChangeCheck("individual", value)}
						/>
					}
					label={<Typography className="queue-title">Individual</Typography>}
					labelPlacement="end"
				/>
			</Stack>
			<Stack>{!isValid && <TierAlertError text={"Must select between queue and individual"} />}</Stack>
		</Stack>
	);
}
Queues.propTypes = {
	data: PropTypes.shape({
		hasQueues: PropTypes.bool,
		individual: PropTypes.bool,
	}),
	showDivider: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionChange: PropTypes.func,
};
